// Copyright (c) billwerk GmbH. All rights reserved.
'use strict';

var AccountingExportCreateController = function ($scope, AccountingExportSettings, $http, PUtill, $location, DatepickerUtils) {
    $scope.endDate = new Date();

    $scope.isValidData = function () {
        return !!$scope.format;
    };

    $scope.export = function (kind) {
        exportPostings(kind, $scope.format, $scope.endDate);
    }

    function exportPostings(kind, format, endDate) {
        let inclusiveEndString = DatepickerUtils.toShortBerlinDateString(endDate);
        let dto = {
            Kind: kind,
            ExportedDateRange: { InclusiveEnd: inclusiveEndString },
            Files: [ { Format: format } ]
        };

        $http({
            method: "POST",
            url: "/api/v1/accountingexports/",
            params: {},
            data: dto,
            headers: {},
            cache: false
        }).then(function (response) {
            $scope.datev = response.data;
            $location.path("/activities/accountingexport/exports");
        });
    }
};
AccountingExportCreateController.$inject = ['$scope', 'AccountingExportSettings', '$http', 'PUtill', '$location', 'DatepickerUtils'];
